import {mapActions, mapGetters, mapMutations} from 'vuex';
import Item from '../../components/item/index.vue'
import BtnLoadMore from '@/components/atoms/buttons/load-more/index.vue'
import HeadFilter from '@/components/features/head-filter/index.vue'
import {seo} from '@/mixins/seo'

export default {
    name: 'tests',
    mixins: [seo],
    components: {
        Item,
        BtnLoadMore,
        HeadFilter
    },
    beforeRouteLeave(to, from, next) {
        if (to.name === 'tests-rules' ||
            (to.name === 'tests-check') ||
            (to.name === 'tests-report')) {
        } else {
            this.changeCategory()
        }
        next();
    },
    created() {
        this.seo.title = this.$t('tests')
        if (!this.categories.length) {
            this.fetchCategories();
        }
        this.changeHeader({
            show: false,
            title: ''
        })

        if (!this.isListLoading && !this.list.length) {
            this.fetchData({isResetList: true})
        }
    },
    computed: {
        ...mapGetters({
            list: 'tests/list',
            listLength: 'tests/listLength',
            isListLoading: 'tests/isListLoading',

            categories: 'education/categories',
            isLoadingCategories: 'education/isLoadingCategories',
        })
    },
    methods: {
        ...mapActions({
            fetchData: 'tests/GET_LIST',
            fetchCategories: 'education/GET_CATEGORIES',
        }),
        ...mapMutations({
            changeCategory: 'tests/CHANGE_CATEGORY',
            setCategories: 'education/SET_CATEGORIES',
            changeHeader: 'tests/CHANGE_HEADER'
        }),
        selectedRoute(item) {
            if (item.userTest.data.hasOwnProperty('status')) {
                switch (item.userTest.data.status) {
                    case 'in_process': {
                        return 'tests-rules'
                    }
                    case 'canceled': {
                        return 'tests-rules'
                    }
                    case 'completed': {
                        return 'tests-check'
                    }
                    default: {
                        return 'tests-report'
                    }
                }
            }
            return 'tests-rules'
        }
    },
}
